import map from 'lodash/map';
import keyBy from 'lodash/keyBy';
import get from 'lodash/get';
import parkingTypes from './parkingTypes';
import { defineMessages } from 'react-intl';

const parkingTypeLabels = (answer, intl) => {
  const keyByParking = keyBy(parkingTypes, 'key');
  return map(answer, (item) => {
    const label = get(keyByParking, [item, 'label']);
    return label && intl.formatMessage(label);
  });
};

const parkingMsgs = defineMessages({
  parkingLabel: { id: 'shared.parking_faq.label', defaultMessage: 'Parking' },
  types: { id: 'shared.parking_faq.types', defaultMessage: 'Parking options' },
  description: { id: 'shared.parking_faq.description', defaultMessage: 'Parking description' },
  availability: { id: 'shared.parking_faq.is_available', defaultMessage: 'No parking options at this space' }
});

export const parkingFAQ = (answer, intl) => {
  return (
    {
      types: {
        label: answer && parkingMsgs.types,
        description: parkingTypeLabels(answer, intl).join(', ')
      },
      description: {
        label: answer && parkingMsgs.description,
        description: answer
      },
      is_available: {
        label: !answer && parkingMsgs.availability
      }
    }
  );
};

export const parkingQuestions = {
  parking: {
    label: parkingMsgs.parkingLabel,
    icon: 'parking',
    keys: [
      'types',
      'description',
      'is_available'
    ],
    faq: parkingFAQ
  }
};

exports.parkingFAQ = parkingFAQ;
